import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DonutKpiDataObject, type DonutKpiState } from '../../types'

const initialState: DonutKpiState = {
  isLoading: false,
  error: false,
  data: undefined,
  httpStatus: 0
}

const alarmBreakdownDonutSlice = createSlice({
  name: 'alarmBreakdownDonut',
  initialState,
  reducers: {
    alarmBreakdownDonutLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    alarmBreakdownDonutUpdateAction: (state, action: PayloadAction<{ data: DonutKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    alarmBreakdownDonutErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    }
  }
})

export const {
  alarmBreakdownDonutLoadingAction,
  alarmBreakdownDonutUpdateAction,
  alarmBreakdownDonutErrorAction
} = alarmBreakdownDonutSlice.actions

export default alarmBreakdownDonutSlice.reducer
